import { render, staticRenderFns } from "./CInfoTextarea.vue?vue&type=template&id=3b8a3c7a&scoped=true&"
import script from "./CInfoTextarea.vue?vue&type=script&lang=ts&"
export * from "./CInfoTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./CInfoTextarea.vue?vue&type=style&index=0&id=3b8a3c7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a3c7a",
  null
  
)

export default component.exports